import Alpine from "alpinejs";

Alpine.data('AnnouncementBanner', () => ({
    activeIndex: 1,
    childrenTotal: 0,
    interval: null,
    bannerHeight: 0,
    childHeight: 'auto',
    init(){
        this.children = this.$el.querySelectorAll('.announcement');
        this.childrenTotal = this.children.length;
        this.startInterval();
        this.calcHeight();
    },

    stopInterval(){
        clearInterval(this.interval)
    },
    startInterval() {
        this.interval = setInterval(() => {
            if(this.activeIndex != this.childrenTotal){
                this.activeIndex++
            } else {
                this.activeIndex = 1;
            }
        }, 5000);
    },
    calcHeight(){
        this.bannerHeight = 0;
        Array.from(this.children).forEach(el => {
            let offsetHeight = el.offsetHeight;
            
            if(offsetHeight > this.bannerHeight){
                this.bannerHeight = offsetHeight;
            }
        });
        this.childHeight = this.bannerHeight + 'px'
    }

}));